import React from 'react';
import styles from './UsuarioNovo.module.css';
import firebase from '../../Utils/Firebase';
import 'firebase/auth';
import 'firebase/firestore';
import Input from '../forms/Input';
import Button from '../forms/Button';
import Head from '../Head';

const UsuarioNovo = () => {
  const [username, setUsername] = React.useState('');
  const [senha, setSenha] = React.useState('');
  const [msgTipo, setMsgTipo] = React.useState('');
  const [msg, setMsg] = React.useState('');
  const [carregando, setCarregando] = React.useState();
  

  function cadastrar() {
    setCarregando(1);
    setMsgTipo(null);

    if (!username || !senha) {
      setMsgTipo('erro');
      setMsg('Você precisa informar o email e senha para fazer o cadastro!');
      return;
    }
    firebase
      .auth()
      .createUserWithEmailAndPassword(username, senha)
      .then((r) => {
        setCarregando(0)
        setMsgTipo('sucesso');
      })
      .catch((erro) => {
        setCarregando(0)

        setMsgTipo('erro');
        
        switch (erro.message) {
          case 'Password should be at least 6 characters':
            setMsg('A senha deve ter pelo menos 6 caracteres!');
            break;
          case 'The email address is already in use by another account.':
            setMsg('Este email já está sendo ultilizado por outro usuário!');
            break;
          case 'The email address is badly formatted.':
            setMsg('O formato do seu email é inválido!');
            break;
          default:
            setMsg('Não foi possível cadastrar. Tente novamente mais tarde!');
            break;
        }
      });




  }

  return (
    <>
    <Head title="Cantinho d' Bolos | Cadastro" description="Esses São nossos produtos." />
      <div className="animeLeft">
        <h1 className={styles.atencao}>
          ATENÇÃO!!! ESSA É UMA PÁGINA EXCLUSIVA PARA ADMINISTRADORES DO
          ESTABELECIMENTO.{' '}
        </h1>
        <form className={styles.form}>
          <div className={styles.logTitulo}>
            <h1>Cadastro</h1>
          </div>

          <Input
            name="username"
            id={username}
            type="email"
            onChange={(e) => setUsername(e.target.value)}
            label="Usuário"
          />
          <Input
            name="senha"
            id={senha}
            type="password"
            onChange={(e) => setSenha(e.target.value)}
            label="Senha"
          />
          {carregando ?  <Button disabled>Carregando...</Button> : <Button type="button" disabled onClick={cadastrar}>
            Cadastrar
          </Button>}
          

          <div className={styles.msgLogin}>
            {msgTipo === 'sucesso' && (
              <span>
                <strong>Wow! Usuário cadastrado com sucesso!</strong>
              </span>
            )}

            {msgTipo === 'erro' && (
              <span>
                <strong>Ops! {msg}</strong>
              </span>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default UsuarioNovo;
